import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { pickPatientWritableFields } from "../constants/patientFormDefaults";
import { ACTIONS, writeLog } from "./auditService";
import { db } from "./firebase";

export async function createPatient(payload, actor) {
  const writablePayload = pickPatientWritableFields(payload);
  const docRef = await addDoc(collection(db, "patients"), {
    ...writablePayload,
    createdBy: actor.uid,
    createdByName: actor.displayName,
    createdAt: serverTimestamp(),
    updatedBy: actor.uid,
    updatedByName: actor.displayName,
    updatedAt: serverTimestamp(),
  });
  await writeLog(actor, ACTIONS.CREATE_PATIENT, "patient", docRef.id, `Patient: ${payload.firstName} ${payload.lastName}`);
  return docRef.id;
}

export async function updatePatient(patientId, updates, actor) {
  const writableUpdates = pickPatientWritableFields(updates);
  await updateDoc(doc(db, "patients", patientId), {
    ...writableUpdates,
    updatedBy: actor.uid,
    updatedByName: actor.displayName,
    updatedAt: serverTimestamp(),
  });
  await writeLog(actor, ACTIONS.UPDATE_PATIENT, "patient", patientId, `Patient: ${updates.firstName || ""} ${updates.lastName || ""}`.trim());
}

export async function deletePatient(patientId, actor, targetLabel) {
  await deleteDoc(doc(db, "patients", patientId));
  await writeLog(actor, ACTIONS.DELETE_PATIENT, "patient", patientId, targetLabel);
}

export async function getPatient(patientId) {
  const snap = await getDoc(doc(db, "patients", patientId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function listPatients(max = 100, viewer = null) {
  const isAdmin = viewer?.role === "admin";
  const viewerUid = viewer?.uid;
  const base = collection(db, "patients");

  if (!isAdmin && viewerUid) {
    const snap = await getDocs(query(base, where("createdBy", "==", viewerUid), limit(max)));
    return snap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
  }

  const snap = await getDocs(query(base, orderBy("createdAt", "desc"), limit(max)));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getPatientCount() {
  const snap = await getDocs(collection(db, "patients"));
  return snap.size;
}
